import React from "react";
import { Col, Row } from "react-bootstrap";
import { menuData, profileData } from "../const/profileConstants";
import BaseSectionItem from "./BaseSectionItem";
import SkillOverlayItem from "./SkillOverlayItem";

export const SkillItem = () => {
  const generateSkillColumn = (skillInfo, topMargin = false) => {
    return (
      <>
        <b>{skillInfo.label}</b>
        <ul type="square" className={topMargin ? "mt-10p" : ""}>
          {skillInfo.list.map((skill) => (
            <li className="fit-width">
              <SkillOverlayItem skill={skill} />
            </li>
          ))}
        </ul>
      </>
    );
  };

  return (
    <BaseSectionItem header={menuData[4].value}>
      <Row>
        {profileData.skills.slice(0, 2).map((skillInfo, index) => (
          <Col>{generateSkillColumn(skillInfo, index > 0)}</Col>
        ))}

        <Col className="ml-5p">
          {profileData.skills
            .slice(2)
            .map((skillInfo) => generateSkillColumn(skillInfo))}
        </Col>
      </Row>
    </BaseSectionItem>
  );
};
